import { styled } from '@mui/material';

import {
  Typography,
  Box,
  ButtonsContainer,
  Divider,
  InfoBox,
  RoundIcon,
  Button,
} from '@app-velocity/ui';

import { PrototypesIcon } from '@app-velocity/icons';
import { useI18n } from '@app-velocity/i18n';

import { useAppContext } from '@app-velocity/config';

const StyledBox = styled(Box)({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'pre-wrap',
  flex: 1,
});

const DividerContainer = styled('div')({
  padding: '0px 45%',
  boxSizing: 'border-box',
  width: '100%',
});

const StyledSubtitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const NoFlows = () => {
  const { t } = useI18n();
  const { scenarioExample } = useAppContext();

  const openExample = (e: React.MouseEvent) => {
    e.stopPropagation();

    window.open(scenarioExample);
  };

  return (
    <StyledBox>
      <RoundIcon icon={<PrototypesIcon />} />
      <InfoBox
        title="prototypes:no_flows"
        description="prototypes:no_flows_description"
      />
      <DividerContainer>
        <Divider textAlign="left" text="" />
      </DividerContainer>
      <StyledSubtitle>{t('prototypes:no_prototype_yet')}</StyledSubtitle>
      <ButtonsContainer>
        <Button onClick={openExample} variant="contained" color="secondary">
          {t('shared:where_to_start.example')}
        </Button>
      </ButtonsContainer>
    </StyledBox>
  );
};
